import { createCRUDHook } from './createCRUDHook';
import { QtyYieldDto } from 'utils/models';
import { TLKP_QTY_YIELD, GET_QTY_DATA_BY_LENGTH } from './apiEndPoints';

interface QtyYieldCustomOperations {
  getQtyYieldDataByLength: (length: number) => Promise<QtyYieldDto>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  QtyYieldDto,
  QtyYieldDto,
  QtyYieldCustomOperations
>({
  entityName: 'QtyYield',
  endpoint: TLKP_QTY_YIELD,

  customOperations: (auth) => ({
    getQtyYieldDataByLength: async (length: number): Promise<QtyYieldDto> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          `${TLKP_QTY_YIELD}${GET_QTY_DATA_BY_LENGTH}?length=${length}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const QtyYieldContext = Context;
export const useQtyYieldManager = useManager;
export const useQtyYield = useConsumer;
